<template>
	<b-container fluid>
		<page-title><h2><router-link :to="{ name: 'InvoiceTaxTypeList' }" class="nav-link">Stawki podatku VAT</router-link></h2>
		<div class="page-title__buttons"><router-link :to="{ name: 'InvoiceTaxTypeCreate' }" class="btn btn-default"><span>Dodaj stawkę</span><svg-icon name="plus"/></router-link></div></page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger">{{ error }}</div>

			<div v-if="!loading">	
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover table-clickable table-search">
						<thead>
						<tr>
							<th>Nazwa</th>
							<th>Stawka</th>
							<th></th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item in items">
							<td><router-link v-if="item" :to="{name: 'InvoiceTaxTypeShow', params: { id: item['id'] }}">{{ item['name'] }}</router-link></td>
							<td><router-link v-if="item" :to="{name: 'InvoiceTaxTypeShow', params: { id: item['id'] }}">{{ item['tax'] }}</router-link></td>
							<td>
								<router-link :to="{name: 'InvoiceTaxTypeUpdate', params: { id: item['id'] }}" v-b-tooltip.hover.bottom title="Edytuj" class="btn btn-icon">
									<svg-icon name="edit"/>
								</router-link>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    computed: mapGetters({
      error: 'invoicetaxtype/list/error',
      items: 'invoicetaxtype/list/items',
      loading: 'invoicetaxtype/list/loading',
      view: 'invoicetaxtype/list/view'
    }),
    methods: mapActions({
      getPage: 'invoicetaxtype/list/getItems'
    }),
    created () {
      this.$store.dispatch('invoicetaxtype/list/getItems')
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?4a685f2a